export default __webpack_public_path__ + "279f25d.png";